module.exports = __webpack_public_path__ + "img/id.7b21ce5b.webp";